import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

const MicrosoftPlannerComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1402 30.8594C15.2459 32.7536 12.1747 32.7536 10.2805 30.8594L3.42075 23.9998C1.5265 22.1055 1.5265 19.0344 3.42075 17.1402L10.2805 10.2805C12.1747 8.38631 15.2459 8.38631 17.1402 10.2805L23.9999 17.1402C25.8942 19.0344 25.8942 22.1055 23.9999 23.9998L17.1402 30.8594Z"
      fill="url(#microsoftplanner_paint0_linear_320097_1909)"
    />
    <path
      d="M17.1402 30.8594C15.2459 32.7536 12.1747 32.7536 10.2805 30.8594L3.42075 23.9998C1.5265 22.1055 1.5265 19.0344 3.42075 17.1402L10.2805 10.2805C12.1747 8.38631 15.2459 8.38631 17.1402 10.2805L23.9999 17.1402C25.8942 19.0344 25.8942 22.1055 23.9999 23.9998L17.1402 30.8594Z"
      fill="url(#microsoftplanner_paint1_linear_320097_1909)"
    />
    <path
      d="M3.42065 24.0002C5.31496 25.8945 8.38624 25.8945 10.2806 24.0002L30.8603 3.42072C32.7546 1.52643 35.8259 1.52642 37.7202 3.4207L44.5801 10.2805C46.4744 12.1748 46.4744 15.246 44.5801 17.1403L24.0003 37.7198C22.106 39.6141 19.0347 39.6141 17.1404 37.7198L3.42065 24.0002Z"
      fill="url(#microsoftplanner_paint2_linear_320097_1909)"
    />
    <path
      d="M3.42065 24.0002C5.31496 25.8945 8.38624 25.8945 10.2806 24.0002L30.8603 3.42072C32.7546 1.52643 35.8259 1.52642 37.7202 3.4207L44.5801 10.2805C46.4744 12.1748 46.4744 15.246 44.5801 17.1403L24.0003 37.7198C22.106 39.6141 19.0347 39.6141 17.1404 37.7198L3.42065 24.0002Z"
      fill="url(#microsoftplanner_paint3_linear_320097_1909)"
    />
    <path
      d="M10.2803 30.8596C12.1746 32.7539 15.2459 32.7539 17.1402 30.8596L30.8601 17.14C32.7544 15.2457 35.8257 15.2457 37.72 17.1399L44.5799 23.9998C46.4742 25.894 46.4742 28.9653 44.5799 30.8596L30.86 44.5792C28.9657 46.4735 25.8944 46.4735 24.0001 44.5792L10.2803 30.8596Z"
      fill="url(#microsoftplanner_paint4_linear_320097_1909)"
    />
    <path
      d="M10.2803 30.8596C12.1746 32.7539 15.2459 32.7539 17.1402 30.8596L30.8601 17.14C32.7544 15.2457 35.8257 15.2457 37.72 17.1399L44.5799 23.9998C46.4742 25.894 46.4742 28.9653 44.5799 30.8596L30.86 44.5792C28.9657 46.4735 25.8944 46.4735 24.0001 44.5792L10.2803 30.8596Z"
      fill="url(#microsoftplanner_paint5_linear_320097_1909)"
    />
    <defs>
      <linearGradient
        id="microsoftplanner_paint0_linear_320097_1909"
        x1="13.7102"
        y1="8.85989"
        x2="5.95609"
        y2="25.425"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(118 43% 32%) h s 60%)" />
        <stop offset="1" stopColor="hsl(from hsl(118 43% 32%) h s 27%)" />
      </linearGradient>
      <linearGradient
        id="microsoftplanner_paint1_linear_320097_1909"
        x1="17.3643"
        y1="22.2947"
        x2="11.058"
        y2="16.1031"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.12172" stopColor="hsl(from hsl(118 43% 32%) h s 20%)" />
        <stop
          offset="1"
          stopColor="hsl(from hsl(118 43% 32%) h s 45%)"
          stopOpacity="0"
        />
      </linearGradient>
      <linearGradient
        id="microsoftplanner_paint2_linear_320097_1909"
        x1="35.6792"
        y1="1.99994"
        x2="20.0719"
        y2="39.4359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(118 43% 32%) h s 57%)" />
        <stop offset="1" stopColor="hsl(from hsl(118 43% 32%) h s 25%)" />
      </linearGradient>
      <linearGradient
        id="microsoftplanner_paint3_linear_320097_1909"
        x1="35.6792"
        y1="1.99994"
        x2="20.0719"
        y2="39.4359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(118 43% 32%) h s 57%)" />
        <stop
          offset="0.677403"
          stopColor="hsl(from hsl(118 43% 32%) h s 42%)"
        />
        <stop offset="1" stopColor="hsl(from hsl(118 43% 32%) h s 43%)" />
      </linearGradient>
      <linearGradient
        id="microsoftplanner_paint4_linear_320097_1909"
        x1="35.0011"
        y1="15.7494"
        x2="27.668"
        y2="45.9986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(118 43% 32%) h s 62%)" />
        <stop offset="1" stopColor="hsl(from hsl(118 43% 32%) h s 31%)" />
      </linearGradient>
      <linearGradient
        id="microsoftplanner_paint5_linear_320097_1909"
        x1="35.3974"
        y1="16.5317"
        x2="21.2939"
        y2="44.0507"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="hsl(from hsl(118 43% 32%) h s 62%)" />
        <stop offset="1" stopColor="hsl(from hsl(118 43% 32%) h s 54%)" />
      </linearGradient>
    </defs>
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components. These icons re-render on every parent render otherwise, and their
// props (className, aria-*) are stable across almost all of them.
export const MicrosoftPlanner = memo(MicrosoftPlannerComponent);
